import { ShoppingCart } from 'lucide-react'
import { useCart } from '@store/cart/CartProvider'

export function CartIcon() {
  const { count, setOpen } = useCart()

  return (
    <button
      onClick={() => setOpen(true)}
      className="relative p-2 rounded-lg text-gray-500 hover:text-orange-600 hover:bg-orange-50 transition-colors"
      title={`Cesta de Transfer${count > 0 ? ` (${count} articulo${count !== 1 ? 's' : ''})` : ''}`}
    >
      <ShoppingCart className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 flex items-center justify-center h-5 min-w-[20px] px-1 rounded-full bg-orange-500 text-[10px] font-bold text-white leading-none">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  )
}
